<template>
  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th class="user-email-column">E-posta</th>
        <th class="status-column">{{$t('status_payment')}}
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.22586 2.35999L2.36584 0.5L0.505859 2.35999" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.36523 9.5V0.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.77539 7.64014L7.63541 9.50012L9.49539 7.64014" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.63672 0.5V9.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </th>
        <th class="role-column">{{$t('role_table')}}
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.22586 2.35999L2.36584 0.5L0.505859 2.35999" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.36523 9.5V0.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.77539 7.64014L7.63541 9.50012L9.49539 7.64014" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.63672 0.5V9.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </th>
        <th class="department-column">Departman
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.22586 2.35999L2.36584 0.5L0.505859 2.35999" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.36523 9.5V0.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.77539 7.64014L7.63541 9.50012L9.49539 7.64014" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.63672 0.5V9.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </th>
        <th class="creation-date-column">{{$t('reports.creation')}}
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.22586 2.35999L2.36584 0.5L0.505859 2.35999" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.36523 9.5V0.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.77539 7.64014L7.63541 9.50012L9.49539 7.64014" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.63672 0.5V9.5" stroke="#292D32" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </th>
        <th class="last-login-column">{{$t('reports.last_entry')}}</th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="loading">
        <td colspan="6" class="table-loading">
        </td>
      </tr>

      <tr v-else-if="!loading && users.length === 0" class="tr-class">
        <td colspan="6" class="table-loading">
          <span class="text">{{$t('no_data_found')}}</span>
        </td>
      </tr>

      <tr class="tr-class" v-else v-for="user in users" :key="user.userId">
        <td class="td-style user-email-cell">
          <div class="user-email-content">
            <div class="user-initials">{{ getInitials(user.email) }}</div>
            <span class="user-email" :title="user.email">
                {{ truncateText(user.email, 35) }}
              </span>
          </div>
        </td>

        <td class="td-style status-cell">
            <span class="status-badge" :class="user.status ? 'active' : 'inactive'">
              <span class="status-dot"></span>
              <span v-if="user.status">{{$t('active')}}</span>
              <span v-else>{{$t('inactive')}}</span>
            </span>
        </td>

        <td class="td-style role-cell">
          <div class="role-info">
            <template v-if="user.role?.name">
              <span class="role-name">{{ user.role.name }}</span>
              <span class="role-key">{{ user.role.key }}</span>
            </template>
            <template v-else>
              <span class="role-name">{{$t('role_found')}}</span>
              <span class="role-key">-</span>
            </template>
          </div>
        </td>

        <td class="td-style department-cell">
          <template v-if="user.departments">
            <span class="department-name">{{ truncateText(user.departments, 20) }}</span>
          </template>
          <template v-else>
            <span class="department-name">{{$t('department_found')}}</span>
          </template>
        </td>

        <td class="td-style creation-date-cell">
          <span class="creation-date">{{ formatDate(user.createdAt) }}</span>
        </td>

        <td class="td-style last-login-cell">
          <template v-if="user.lastLogin">
            <span class="last-login">{{ formatDate(user.lastLogin) }}</span>
          </template>
          <template v-else>
            <span class="last-login no-login">{{$t('reports.no_entry_at_all')}}</span>
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {ref, onMounted, computed, watch, defineExpose} from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'UserFeaturesTable',

  props: {
    fetchUsers: {
      type: Function,
      required: true
    },
    users: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const { locale } = useI18n();
    const selectAll = ref(false);
    const selectedUserIds = ref([]);
    const displayUsers = computed(() => props.users);

    const localeMap = {
      'tr': 'tr-TR',
      'en': 'en-US'
    };

    watch(() => props.users, (newUsers) => {
      selectedUserIds.value = [];
      selectAll.value = false;
    }, { deep: true, immediate: true });

    const toggleAll = () => {
      if (selectAll.value) {
        selectedUserIds.value = displayUsers.value.map(user => user.userId);
      } else {
        selectedUserIds.value = [];
      }
    };

    const toggleUser = (e, userId) => {
      if (e.target.checked) {
        selectedUserIds.value.push(userId);
      } else {
        selectedUserIds.value = selectedUserIds.value.filter(id => id !== userId);
      }
    };

    const truncateText = (text, length) => {
      if (!text) return '';
      return text.length > length ? text.slice(0, length) + '...' : text;
    };

    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';

      const currentLocale = localeMap[locale.value] || 'tr-TR';
      let date;

      // Backend'den "10.01.2025 12:30" formatında geliyorsa parse et
      if (dateString.includes('.')) {
        const dateOnly = dateString.split(' ')[0]; // "10.01.2025"
        const parts = dateOnly.split('.'); // ["10", "01", "2025"]

        if (parts.length === 3) {
          const day = parts[0];
          const month = parts[1];
          const year = parts[2];
          date = new Date(`${year}-${month}-${day}`);
        }
      } else {
        // Normal ISO formatında geliyorsa
        date = new Date(dateString);
      }

      if (!date || isNaN(date.getTime())) return 'N/A';

      return date.toLocaleDateString(currentLocale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    };

    const getInitials = (email) => {
      if (!email) return 'NA';
      const parts = email.split('@');
      const username = parts[0];

      if (username.length >= 2) {
        return username.substring(0, 2).toUpperCase();
      }
      return username.charAt(0).toUpperCase() + 'A';
    };

    const filterData = async (filters) => {
      let status = 2;
      if (filters.status === 'active') {
        status = 1;
      } else if (filters.status === 'passive') {
        status = 0;
      }

      if (props.fetchUsers && typeof props.fetchUsers === 'function') {
        await props.fetchUsers(status);
      }
    };

    const refreshData = async (status = 2) => {
      if (props.fetchUsers && typeof props.fetchUsers === 'function') {
        await props.fetchUsers(status);
      }
    };

    onMounted(async () => {
      if (props.fetchUsers && typeof props.fetchUsers === 'function') {
        await props.fetchUsers(2);
      }
    });

    defineExpose({
      filterData,
      refreshData
    });

    return {
      selectAll,
      selectedUserIds,
      users: displayUsers,
      toggleAll,
      toggleUser,
      truncateText,
      formatDate,
      getInitials,
      filterData,
      refreshData
    };
  }
}
</script>

<style scoped>
.user-email-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-initials {
  width: 32px;
  height: 32px;
  background: #F3F4F6;
  color: #374151;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.user-email {
  font-weight: 500;
  color: #101828;
  line-height: 20px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-badge.active .status-dot {
  background: #3da33e;
}

.status-badge.inactive .status-dot {
  background: #f09460;
}

.role-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.role-name {
  font-weight: 500;
  color: #101828;
  font-size: 14px;
  line-height: 18px;
}

.role-key {
  font-size: 12px;
  color: #667085;
  font-weight: 400;
}

.department-name {
  color: #475467;
  font-size: 14px;
  font-weight: 400;
}

.creation-date {
  color: #475467;
  font-size: 14px;
  font-weight: 400;
}

.last-login {
  color: #475467;
  font-size: 14px;
  font-weight: 400;
}

.last-login.no-login {
  font-family:'euclid_circular_a Std', sans-serif ;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.table-loading {
  text-align: center;
  padding: 40px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.table-loading .text {
  color: #667085;
  font-size: 14px;
  font-weight: 400;
}

.user-email-column {
  width: 35%;
  min-width: 250px;
}

.status-column {
  width: 12%;
  min-width: 100px;
}

.role-column {
  width: 20%;
  min-width: 150px;
}

.department-column {
  width: 15%;
  min-width: 120px;
}

.creation-date-column {
  width: 10%;
  min-width: 100px;
}

.last-login-column {
  width: 8%;
  min-width: 100px;
}

@media (max-width: 768px) {
  .user-email-content {
    gap: 8px;
  }

  .user-initials {
    width: 28px;
    height: 28px;
    font-size: 11px;
  }

  .role-info {
    gap: 1px;
  }

  .role-name {
    font-size: 12px;
  }

  .role-key {
    font-size: 10px;
  }
}
</style>
